import logo from '../../assets/images/mimararchi.png';
import Platform from '../Platform';
import BusinessLinks from '../BusinessLinks';
import { useState } from 'react';
import BlueProfile from '../BlueProfile';
import RedProfile from '../RedProfile';

const CorporateMocket = ({ profile }) => {
    let c;
    const [showMore, setShowMore] = useState(false);
    console.log(profile.profiles[profile.activeProfile].colorTheme)
    if (profile.profiles[profile.activeProfile].colorTheme === '#d9d9d9') {
        c = '217, 217, 217'
    }
    else {
        c = profile.profiles[profile.activeProfile].colorTheme
    }
    console.log(c);
    return (
        <div className="profileContainer">
            <div className="imgBundleContainer" style={{"background": profile.type === 'Blue' ? "linear-gradient(to top, white 0%, white 42%, #172c3d 42%, #172c3d 100% )": "white"}}>
                {
                    profile.type === "Blue" ? <BlueProfile job={profile.profiles[profile.activeProfile].job} name={profile.name} image1={profile.profiles[profile.activeProfile].image1} /> : <RedProfile job={profile.job} name={profile.name} image1={profile.profiles[profile.activeProfile].image1} />
                }
            </div>
            
            <div className={profile.type === "Blue"? "contactButtonsBlue" : "contactButtons"}>
                <a style={{"pointerEvents":"none"}} href={profile.profiles[profile.activeProfile].contact_link}> SAVE CONTACT </a>
                <a style={{"pointerEvents":"none", 'color': profile.type === "Blue"? 'white':"black" , "background": profile.type === "Blue"? "#172c3d":"#972721"  }} className={profile.type ==="Blue" ?'taskOpenBtnExBlue':"taskOpenBtnEx"} href=''> EXCHANGE INFO </a>
            </div>
            <p style={{"width":"90%","marginBottom":"0px"}}>
                Contact Info
            </p>
            <div className="businessLinkHolder">
                {profile.profiles[profile.activeProfile].socialMedia && profile.profiles[profile.activeProfile].socialMedia.map((app, index) => (
                    <BusinessLinks corp={false} key={index} props={app} color={profile.profiles[profile.activeProfile].colorTheme} idx={index} />
                ))}
            </div>
        </div>
    );
}
export default CorporateMocket;